import { deleteCall, getCall, postCall } from "../utils/calls";
import {
  dispatchErrorMessage,
  loadingToast,
  updateToast,
} from "../utils/toast";

export const getIntents = async () => {
  const bot_id = localStorage.getItem("bot");
  const res = await getCall("/ia/" + bot_id);
  if (res[0]) {
    return res[0].intents;
  } else return null;
};

export const getButtonsIntents = async () => {
  const bot_id = localStorage.getItem("bot");
  const res = await getCall("/ia/buttons/" + bot_id);
  if (res[0]) {
    return res[0];
  } else return null;
};

export const addNewIntent = async (newIntent) => {
  const bot_id = localStorage.getItem("bot");
  const id = loadingToast();
  const data = { 
    name: newIntent.name, 
    description: newIntent.description 
  };
  const res = await postCall("/ia/selector/add/" + bot_id, data);
  if (res[0]) {
    updateToast(id, "success", "Intención creada correctamente.");
    return res[0];
  } else {
    dispatchErrorMessage(id, res, "Error al crear la intención.");
    return null;
  }
};

export const generateWithAi = async (urls) => {
  const bot_id = localStorage.getItem("bot");
  const id = loadingToast("Generando intenciones con IA...");
  const data = { urls: urls };
  const res = await postCall("/ia/selector/ai-identifier/" + bot_id, data);
  
  if (!res || !res[0]?.task_id) {
    dispatchErrorMessage(id, res, "Error al generar intenciones con IA.");
    return null;
  }

  const taskId = res[0].task_id;
  const maxRetries = 50;
  const delay = 5000; // 5 segundos
  let attempt = 0;

  while (attempt < maxRetries) {
    attempt++;

    const statusRes = await getCall(`/tasks/status/${bot_id}/${taskId}`);

    if (!statusRes || !statusRes[0]?.data) {
      await new Promise(r => setTimeout(r, delay));
      continue;
    }

    const status = statusRes[0].data.status;
    if (status === "completed") {
      updateToast(id, "success", "Intenciones generadas correctamente.");
      return statusRes[0].data.response?.selector_intents_data || statusRes[0].data.response;
    }

    if (status === "failed") {
      const backendError = statusRes[0].data?.response?.error || "Error al generar intenciones con IA.";
      dispatchErrorMessage(id, null, backendError);
      return null;
    }

    await new Promise(r => setTimeout(r, delay));
  }

  dispatchErrorMessage(id, null, "Tiempo de espera agotado al generar intenciones.");
  return null;
};

export const createWithAi = async (selectedIntentsData) => {
  const bot_id = localStorage.getItem("bot");
  const id = loadingToast();
  const data = { selector_intents_data: selectedIntentsData };
  const res = await postCall("/ia/selector/create/" + bot_id, data);
  if (res[0]) {
    updateToast(id, "success", "Intenciones creadas correctamente.");
    return res[0].selector_intents_data;
  } else {
    dispatchErrorMessage(id, res, "Error al crear intenciones con IA.");
    return null;
  }
};

export const editIntent = async (editedIntent) => {
  const bot_id = localStorage.getItem("bot");
  const id = loadingToast();
  const data = { 
    name: editedIntent.name, 
    description: editedIntent.description,
    is_family: editedIntent.isFamily
  };
  const res = await postCall("/ia/selector/edit/" + bot_id + "/" + editedIntent.category_id + "/" + editedIntent.id, data);
  if (res[0]) {
    updateToast(id, "success", "Intención editada correctamente.");
    return res[0];
  } else {
    dispatchErrorMessage(id, res, "Error al editar la intención.");
    return null;
  }
};

export const deleteIntent = async (intent) => {
  const bot_id = localStorage.getItem("bot");
  const id = loadingToast();
  const res = await postCall(
    "/ia/selector/" + bot_id + "/" + intent.category_id + "/" + intent.id,
    {
      isFamily: intent.isFamily,
    }
  );
  if (res[0]) {
    updateToast(id, "success", "Intención eliminada correctamente.");
    return res[0];
  } else {
    dispatchErrorMessage(id, res, "Error al eliminar la intención.");
    return null;
  }
};
